import {AppSetting} from '../AppSetting';
import {BaseWebApiDAO} from './BaseWebApiDAO';
import {BaseService} from '../Service/BaseService';
import {AppSettingApi} from '../AppSettingApi';


/**
 * PcrDAO
 * PCR系DAO
 */
export class PcrDAO extends BaseWebApiDAO {

	// コンストラクタ
	constructor(svc: BaseService) {
		super(svc);
	}


	/**
	 * getPcrInterviewMst
	 * 問診マスタリストの取得
	 * @returns 問診票
	 */
	public async getPcrInterviewMst() {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token
		};

		const ret = await this.postRequest(AppSettingApi.PCR_INTERVIEW_MST, request);
		return ret;

	}

	/**
	 * savePcrInterview
	 * 問診の保存
	 * @param cert 証明証
	 * @param positive_cert 陽性証明書
	 * @param type 検査種類
	 * @param group 検査枠
	 * @param express 特急希望
	 * @param name 名前（ローマ字）
	 * @param passportNo パスポート番号
	 * @param nationality 国籍
	 * @param collectDate 採取日
	 * @param specimen_number 検体番号
	 * @param pcrExamineRemark 備考
	 */
	public async savePcrUserInterview(cert: string, positive_cert: string, type: string, group: string, express: boolean,
									name: string, passportNo: string, nationality: number, collectDate: Date,
									specimen_number: number, pcrExamineRemark: string) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token,
			cert,
			positive_cert,
			type,
			group,
			name,
			passport_no: passportNo,
			nationality,
			express,
			collect_date: collectDate,
			specimen_num: specimen_number,
			pcr_examine_remark: pcrExamineRemark,
		};

		return await this.postRequest(AppSettingApi.PCR_INTERVIEW_SAVE, request);

	}


}
